import React from 'react';
import SEO from '../components/SEO';
import { motion } from 'framer-motion';

const TermsConditions = () => {
    return (
        <div className="pt-[80px] min-h-screen bg-gray-50">
            <SEO
                title="Terms & Conditions | BAIC Oman Usage Policy"
                description="Review the Terms and Conditions for using the BAIC Oman website and services. Understand your rights and obligations."
                canonicalUrl="https://baicoman.com/terms-and-conditions"
            />
            <h1 className="sr-only">BAIC Oman Terms and Conditions</h1>
            {/* Hero Section */}
            <div className="relative h-[40vh] bg-black overflow-hidden">
                <div className="absolute inset-0 bg-black/60 z-10" />
                <img
                    src="/assets/images/research-development/rd-hero.jpg"
                    alt="Terms and Conditions"
                    className="w-full h-full object-cover"
                />

                <div className="absolute inset-0 z-20 flex items-center justify-center text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="max-w-4xl px-4"
                    >
                        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight">
                            TERMS & CONDITIONS
                        </h2>
                        <div className="w-20 h-1 bg-red-600 mx-auto rounded-full" />
                    </motion.div>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-4 py-16">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8"
                >
                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Welcome to BAIC</h2>
                        <p className="text-gray-600 leading-relaxed">
                            These Terms and Conditions govern your use of our website and services provided by BAIC is an allied business of Bahwan International Group. By accessing or using our website, you agree to be bound by these Terms and Conditions.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Use of Our Services</h2>
                        <ul className="list-disc pl-6 space-y-4 text-gray-600">
                            <li>
                                <strong>Eligibility:</strong> You must be at least 18 years old to use our services. By using our website, you represent and warrant that you meet this age requirement.
                            </li>
                            <li>
                                <strong>Account:</strong> To access certain features of our website, you may be required to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
                            </li>
                            <li>
                                <strong>Prohibited Activities:</strong> You agree not to engage in any of the following activities:
                                <ul className="list-[circle] pl-6 mt-2 space-y-1">
                                    <li>Violating any applicable laws or regulations.</li>
                                    <li>Interfering with the security or operation of our website.</li>
                                    <li>Transmitting any viruses or harmful code.</li>
                                    <li>Engaging in any fraudulent, deceptive, or misleading activities.</li>
                                </ul>
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
                        <p className="text-gray-600 leading-relaxed">
                            All content on our website, including text, graphics, logos, images, and software, is the property of BAIC or our licensors and is protected by intellectual property laws. You may not use, reproduce, distribute, or create derivative works of our content without our prior written permission.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Disclaimer of Warranties</h2>
                        <p className="text-gray-600 leading-relaxed">
                            Our services are provided "as is" and "as available" without any warranties of any kind, either express or implied. We do not warrant that our services will be uninterrupted, error-free, or free from viruses or other harmful components.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
                        <p className="text-gray-600 leading-relaxed">
                            To the fullest extent permitted by law, BAIC shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from:
                        </p>
                        <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
                            <li>Your use or inability to use our services.</li>
                            <li>Unauthorized access to or use of your account or data.</li>
                            <li>Any conduct or content of any third party on our services.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Indemnification</h2>
                        <p className="text-gray-600 leading-relaxed">
                            You agree to indemnify and hold harmless BAIC and its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses, including reasonable attorneys' fees, arising out of or in any way connected with your use of our services or violation of these Terms and Conditions.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to These Terms and Conditions</h2>
                        <p className="text-gray-600 leading-relaxed">
                            We may update these Terms and Conditions from time to time. We will notify you of any changes by posting the new Terms and Conditions on our website. Your continued use of our services after any changes indicates your acceptance of the new Terms and Conditions.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
                        <p className="text-gray-600 leading-relaxed">
                            These Terms and Conditions are governed by and construed in accordance with the laws of Oman without regard to its conflict of law principles.
                        </p>
                    </section>
                </motion.div>
            </div>
        </div>
    );
};

export default TermsConditions;
